module.exports = __webpack_public_path__ + "images/170_320.jpg";